import { render, staticRenderFns } from "./BackgroundImage.vue?vue&type=template&id=de1aa73a&scoped=true&"
import script from "./BackgroundImage.vue?vue&type=script&lang=js&"
export * from "./BackgroundImage.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundImage.vue?vue&type=style&index=0&id=de1aa73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1aa73a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de1aa73a')) {
      api.createRecord('de1aa73a', component.options)
    } else {
      api.reload('de1aa73a', component.options)
    }
    module.hot.accept("./BackgroundImage.vue?vue&type=template&id=de1aa73a&scoped=true&", function () {
      api.rerender('de1aa73a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/BackgroundImage.vue"
export default component.exports